export const APPEALS_TREND_DATA_API_URL = 'claims-appeals-trend';
export const APPEALS_MEASURE_DOR_HCO_REQUEST_TYPE = "APPEALS_MEASURE_DOR_HCO";
export const APPEALS_MEASURE_DOR_TIN_REQUEST_TYPE = "APPEALS_MEASURE_DOR_TIN";

export const TOP_REASON_TOP_CAT_API_URL = 'claim-metrics/?request-type=NONPAYMENT_TOPCATEGORIES';
export const TOP_REASON_SUB_CAT_API_URL = 'claim-metrics/?request-type=NONPAYMENT_TOPSUBCATEGORIES';
export const DOP_TOP_REASON_TOP_CAT_API_URL = 'dop-claim-metrics/?request-type=TOP_DENIAL_REASONS';
export const DOP_TOP_REASON_SUB_CAT_API_URL = 'dop-claim-metrics/?request-type=TOP_SUB_DENIAL_REASONS';

export const MCR_INVENTORY_API_URL = 'payment-integrity/evaluations/';
export const NONPAYMENT_DETAILS_API_URL = 'claims-bifurcate-metrics/';
export const CLAIMS_TREND_DATA_API_URL = 'claims-trend-metrics/';

export const CLAIMS_RECON_DETAILS_API_URL = 'claims-recon-details/';
export const CLAIMS_RECON_TAT_API_URL = 'claims-recon-avg-tat-metrics/';

// Outcome Volume API URLs
export const PSMS_OUTCOME_REASONS_API_URL = 'claims-recon-outcome-reasons-metrics';
export const PSMS_SUBMISSION_REASONS_API_URL = 'claims-recon-provider-reasons-metrics';
export const PSMS_RECON_DETAILS_API_URL = 'claims-recon-details';

export const CLAIMS_SUMMARY_API_URL = '/claim-metrics/?request-type=PAYMENT_METRICS';
export const CLAIMS_SUMMARY_DOP_API_URL = '/dop-claim-metrics/?request-type=CLAIMS';
export const CLAIMS_APPEALS_SUMMARY_API_URL = '/claims-appeals-summary?request-type=APPEALS_MEASURE_DOR_HCO';
export const CLAIMS_APPEALS_SUMMARY_TIN_API_URL = '/claims-appeals-summary?request-type=APPEALS_MEASURE_DOR_TIN';
export const CLAIMS_BIFURCATE_METRICS_API_URL = '/claims-bifurcate-metrics/';
export const CLAIMS_YIELD_PASS_WISE_METRICS_API_URL = '/claims-yield-pass-wise-metrics/';
export const CLAIMS_YIELD_ALL_PASSES_METRICS_API_URL = '/claims-yield-all-passes-metrics/';
export const AUTOMATION_RATE_CLAIM_METRICS_API_URL = '/automation-rate-claim-metrics/?request-type=PAYMENT_METRICS';
export const CLAIMS_APPEALS_SUBMISSION_API_URL = '/claims-appeals-summary-methods/?request-type=APPEALS_MEASURE_DOR_BREAKDOWN';